import React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { onChangeDataEntryTab, resetDataEntryState } from "../dataEntryDetails/DataEntryDetailsDucks";
import { getTokenLoginRequest, getFeatureFlagsRequest, getPdfTronRequest, FeatureFlags } from "./LoginPageDucks";
import { clearReadOnlyTransactionRequest } from "../landingPage/LandingPageDucks";
import { RootState } from "typesafe-actions";

interface TokenLoginProps {
    getTokenLoginRequest: (token: string) => void,
    getFeatureFlagsRequest: () => void,
    getPdfTronRequest: () => void,
    resetDataEntryState: () => void,
    resetFormState: () => void,
    clearReadOnly: () => void,
    featureFlags?: FeatureFlags,
    onChangeDataEntryTab?: (tab: number) => void,
    match: any,
}

class TokenLogin extends React.Component<TokenLoginProps> {
    componentDidMount() {
        this.props.resetDataEntryState();
        this.props.resetFormState();
        this.props.clearReadOnly();
        if (global.userID === undefined) {
            const id = sessionStorage.getItem("userID");
            global.userID = id ? Number(id) : 0;
        }

        if (!this.props.featureFlags || !Object.keys(this.props.featureFlags).length) {
            this.props.getFeatureFlagsRequest();
        }
        this.props.getPdfTronRequest();

        this.props.onChangeDataEntryTab && this.props.onChangeDataEntryTab(1);

        this.props.getTokenLoginRequest(this.props.match.params.token);
    }

    render() {
        return (<div></div>);
    }
}

function mapDispatchToProps(dispatch: Dispatch) {
    return {
        getTokenLoginRequest: (token: string) => dispatch(getTokenLoginRequest(token)),
        onChangeDataEntryTab: (data: number) => dispatch(onChangeDataEntryTab(data, false)),
        getFeatureFlagsRequest: () => dispatch(getFeatureFlagsRequest()),
        resetDataEntryState: () => dispatch(resetDataEntryState()),
        resetFormState: () => dispatch({ type: "@@redux-form/DESTROY" }),
        clearReadOnly: () => dispatch(clearReadOnlyTransactionRequest()),
        getPdfTronRequest: () => dispatch(getPdfTronRequest()),
    };
}

function mapStateToProps(state: RootState) {
    return {
        featureFlags: state.loginState.featureFlags,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TokenLogin);
